import { format as formatDate } from 'date-fns';
import React from 'react';
import { EditableResourceFields } from '../resources/modelTypes';
import { selectors } from '../add-element/cypressSelectors';

export const formatAddress = ({
  address1, address2, city, state, zipCode,
}: EditableResourceFields) => `${address1}, ${address2 ? address2 + ', ' : ''} ${city}, ${state} ${zipCode}`;

export const formatEventDate = (date: string) => {
  // incoming date format: 'MM/dd/yyyy'
  const [
    month,
    day,
    year,
  ] = date.split('/');

  if (!(day && month && year)) {
    return '';
  }

  const actualDate = new Date(Number(year), Number(month) - 1, Number(day));

  return formatDate(actualDate, 'EEEE, MMMM d, yyyy');
};

export const getEventDateTimeComponent = (date: string | undefined, time: string | undefined, endDate: string | undefined, endTime: string | undefined) => {
  // Incoming date format: 'MM/dd/yyyy'

  // Date is required to be valued
  if (!date) {
    return null;
  }

  const formattedStartDate = formatEventDate(date);
  const startDateTime = time ? `${formattedStartDate} ${time}` : formattedStartDate;

  if (!endDate) {
    return (
      <div data-cy={`${selectors.sections_collapsedField}_datetime`}>
        {startDateTime}
      </div>
    );
  }

  if (date === endDate && time !== endTime) {
    const timeRange = endTime ? `${time} - ${endTime}` : time;

    return (
      <div data-cy={`${selectors.sections_collapsedField}_datetime`}>
        {`${formattedStartDate} ${timeRange}`}
      </div>
    );
  }

  if (date !== endDate) {
    const formattedEndDate = formatEventDate(endDate);
    const endDateTime = endTime ? `${formattedEndDate} ${endTime}` : formattedEndDate;

    return (
      <div data-cy={`${selectors.sections_collapsedField}_datetime`}>
        {`${startDateTime} - ${endDateTime}`}
      </div>
    );
  }

  return (
    <div data-cy={`${selectors.sections_collapsedField}_datetime`}>
      {startDateTime}
    </div>
  );
};
